export default function EditorialSection() {
  return (
    <section className="bg-[#FAF8F5]">

      {/* Full-bleed cinematic image */}
      <div className="relative w-full h-[60vh] md:h-[75vh] min-h-[420px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/7053559b9b5bd5e577f37e2277dc18ca.jpg"
          alt="Table Privé — The art of the table"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/10 to-transparent" />
        <div className="absolute inset-0 flex items-end pb-12 md:pb-16 px-8 md:px-20">
          <p className="font-serif italic text-white/90 text-3xl md:text-5xl max-w-lg leading-tight font-light">
            "Every detail,<br />considered."
          </p>
        </div>
      </div>

      {/* Three-column detail strip */}
      <div className="grid grid-cols-1 md:grid-cols-3">
        {[
          {
            image: "https://readdy.ai/api/search-image?query=extreme%20close%20up%20luxury%20crystal%20champagne%20flute%20half%20filled%20with%20golden%20champagne%20condensation%20on%20glass%20single%20candle%20flame%20reflection%20in%20the%20crystal%20dark%20pitch%20black%20background%20warm%20amber%20glow%20fine%20dining%20aman%20four%20seasons%20editorial%20photography%20razor%20sharp%20detail&width=600&height=700&seq=editorial-v3-002&orientation=portrait",
            alt: "Crystal champagne flute detail",
            caption: "The Glass",
          },
          {
            image: "https://readdy.ai/api/search-image?query=close%20up%20luxury%20white%20garden%20rose%20and%20pale%20ivory%20peony%20bloom%20resting%20on%20dark%20linen%20table%20surface%20single%20candlelight%20warm%20glow%20from%20behind%20petals%20translucent%20soft%20focus%20background%20moody%20editorial%20photography%20four%20seasons%20aman%20private%20dining%20floral%20detail%20refined%20minimal&width=600&height=700&seq=editorial-v3-003&orientation=portrait",
            alt: "Floral detail — luxury tablescape",
            caption: "The Bloom",
          },
          {
            image: "https://readdy.ai/api/search-image?query=extreme%20close%20up%20luxury%20matte%20porcelain%20plate%20thin%20gold%20rim%20resting%20on%20dark%20charcoal%20linen%20tablecloth%20sterling%20silver%20fish%20knife%20and%20fork%20flanking%20single%20taper%20candle%20warm%20reflection%20refined%20editorial%20still%20life%20photography%20aman%20resort%20dining%20table%20detail%20minimal%20elegant&width=600&height=700&seq=editorial-v3-004&orientation=portrait",
            alt: "Fine china plate detail",
            caption: "The Plate",
          },
        ].map((item) => (
          <div key={item.caption} className="relative group overflow-hidden">
            <div className="w-full h-[320px] md:h-[400px] overflow-hidden">
              <img
                src={item.image}
                alt={item.alt}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-500" />
            </div>
            <div className="absolute bottom-0 left-0 w-full p-6 flex items-end justify-between">
              <span className="text-white/70 text-[10px] tracking-[0.25em] uppercase font-light">{item.caption}</span>
              <div className="h-px w-6 bg-[#C9A961]/70" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
